<template>
  <el-row class="height-100 back-color pl-20 pt-20 ql-container ql-snow">
    会员机制
  </el-row>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
